<template>
    <o-select
        placeholder="Select an option"
        v-model="mutatedValue"
        @update:modelValue="handleUpdate"
        class="task-status-select"
        :disabled="disabled"
        expanded
    >
        <option
                v-for="option in options"
                :value="option.id"
                :key="option.id">
            {{ option.name }}
        </option>
    </o-select>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        props: {
            update: {
                type: Function,
                required: true
            },

            field: {
                type: String,
                required: true
            },

            entity: {
                type: Object,
                required: true
            },

            options: {
                type: Array,
                required: true
            },

            disabled: {
                required: false, default: false
            }
        },

        data () {
            return {
                mutatedValue: null,
                updating: false
            }
        },

        computed: {
            value: {
                get () {
                    return this.entity[this.field]
                },
                set(value){
                    this.mutatedValue = value
                }
            },

            changed () {
                return this.value !== this.mutatedValue
            }
        },

        methods: {
            handleUpdate (e) {
                if (this.changed) {
                    let payload = {
                        id: this.entity.id,
                        field: this.field,
                    }
                    payload[this.field] = this.mutatedValue

                    this.updating = true

                    this.update(payload)
                        .then(res => {
                            this.updating = false
                            this.successMessage(_.startCase(this.field) + ' updated')
                            return res
                        }, () => this.mutatedValue = this.value)
                }
            }
        },

        watch: {
            entity: {
                immediate: true,
                deep: true,
                handler () {
                    this.mutatedValue = this.entity[this.field]
                }
            }
        }
    }
</script>
